export default __webpack_public_path__ + "static/media/co-flag.5fe26446.svg";